import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard, Users, UserCog, CalendarClock,
  Monitor, Building2, BarChart3, Settings, Shield,
  Clock, ChevronRight, X
} from 'lucide-react'
import { useAuthStore } from '@/store/authStore'
import clsx from 'clsx'

const ALL_NAV = [
  { to: '/dashboard', label: 'Дашборд', icon: LayoutDashboard, roles: null },
  { to: '/attendance', label: 'Посещаемость', icon: Clock, roles: null },
  { to: '/students', label: 'Студенты', icon: Users, roles: ['super_admin', 'admin', 'department_admin', 'hr', 'viewer', 'operator'] },
  { to: '/employees', label: 'Сотрудники', icon: UserCog, roles: null },
  { to: '/schedules', label: 'Расписания', icon: CalendarClock, roles: ['super_admin', 'admin', 'department_admin', 'operator'] },
  { to: '/departments', label: 'Кафедры/Отделы', icon: Building2, roles: ['super_admin', 'admin', 'department_admin', 'hr'] },
  { to: '/analytics', label: 'Аналитика', icon: BarChart3, roles: null },
  { to: '/devices', label: 'Терминалы', icon: Monitor, roles: ['super_admin', 'admin', 'operator'] },
  { to: '/users', label: 'Пользователи', icon: Shield, roles: ['super_admin', 'admin'] },
  { to: '/settings', label: 'Настройки', icon: Settings, roles: ['super_admin', 'admin'] },
]

export default function Sidebar({ isOpen, onClose }) {
  const user = useAuthStore((s) => s.user)
  const userRole = user?.role_detail?.name

  const navItems = ALL_NAV.filter(({ roles }) =>
    !roles || !userRole || roles.includes(userRole)
  )

  return (
    <aside
      className={clsx(
        'w-64 bg-gray-900 flex flex-col flex-shrink-0 z-30 transition-transform duration-300',
        // Mobile: fixed overlay, Desktop: static
        'fixed md:static inset-y-0 left-0',
        isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'
      )}
    >
      {/* Logo */}
      <div className="px-6 py-5 border-b border-gray-800 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 bg-primary-600 rounded-lg flex items-center justify-center shrink-0">
            <Shield className="w-5 h-5 text-white" />
          </div>
          <div>
            <p className="text-white font-bold text-sm leading-none">СКУД CRM</p>
            <p className="text-gray-400 text-xs mt-0.5">Контроль доступа</p>
          </div>
        </div>
        {/* Close button — mobile only */}
        <button
          onClick={onClose}
          className="md:hidden p-1.5 text-gray-400 hover:text-white hover:bg-gray-800 rounded-lg transition-colors"
        >
          <X size={18} />
        </button>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            onClick={onClose}
            className={({ isActive }) =>
              clsx(
                'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors group',
                isActive
                  ? 'bg-primary-600 text-white'
                  : 'text-gray-400 hover:bg-gray-800 hover:text-white'
              )
            }
          >
            {({ isActive }) => (
              <>
                <Icon className="w-4.5 h-4.5 shrink-0" size={18} />
                <span className="flex-1">{label}</span>
                {isActive && <ChevronRight size={14} className="opacity-60" />}
              </>
            )}
          </NavLink>
        ))}
      </nav>

      {/* User */}
      <div className="px-4 py-4 border-t border-gray-800">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-gray-700 rounded-full flex items-center justify-center text-white text-xs font-bold shrink-0">
            {user?.full_name?.[0] || 'U'}
          </div>
          <div className="overflow-hidden">
            <p className="text-white text-sm font-medium truncate">{user?.full_name}</p>
            <p className="text-gray-400 text-xs truncate">
              {user?.role_detail?.name || user?.username}
            </p>
          </div>
        </div>
      </div>
    </aside>
  )
}
